import SvgMapper from "../../../features/common/SvgMapper";
import { useSelector } from "react-redux";
import { INTERVIEW_PREVIEW_DEFAULT_FIELDS, INTERVIEW_PREVIEW_EXTRA_FIELDS } from "../../../constants/Constants";
import "../../Style.css";

const InterviewPreview = () => {
  const configData = useSelector((state) => state.interviewconfig);
  const { industryOption, interviewRoleOption, interviewTypeOption } = useSelector(
    (state) => state.interviewconfig
  );

  const getLabelById = (options, id) => {
    if (!id || !Array.isArray(options) || options.length === 0) return "";
    const idStr = String(id);
    const found = options.find(
      (opt) => 
        String(opt.id) === idStr || 
        String(opt.value) === idStr ||
        opt.id === id ||
        opt.value === id
    );
    return found?.name || found?.label || found?.value || "";
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center space-x-2 mb-4">
        <div className="w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center text-sm font-bold">
          5
        </div>
        <h3 className="text-lg font-semibold text-gray-900">Interview Preview</h3>
      </div>

      <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-lg p-6">
        <h4 className="font-semibold text-gray-900 mb-4">
          Generated Interview Configuration
        </h4>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {INTERVIEW_PREVIEW_DEFAULT_FIELDS.map(({ key, label, badge, color, defaultValue, format }) => {
            let value = configData[key] ?? defaultValue;
            if (format) value = format(configData[key]);
            return (
              <div key={key} className="flex justify-between items-center">
                <span className="text-gray-600">{label}:</span>
                {badge ? (
                  <span
                    className={`px-2 py-1 rounded-full text-xs font-medium ${
                      color || "bg-blue-100 text-blue-800"
                    }`}
                  >
                    {value}
                  </span>
                ) : (
                  <span className="font-medium text-gray-900">{value}</span>
                )}
              </div>
            );
          })}

          {Object.entries(INTERVIEW_PREVIEW_EXTRA_FIELDS).map(([key, label]) => {
            let value = configData[key];

            if (key === "interviewType") {
              value = getLabelById(interviewTypeOption, configData.interviewType);
            }

            if (key === "industryType") {
              value = getLabelById(industryOption, configData.industryType);
            }

            if (key === "interviewRole") {
              value = getLabelById(interviewRoleOption, configData.interviewRole);
            }

            if (!value) return null;

            return (
              <div key={key} className="flex justify-between items-center">
                <span className="text-gray-600">{label}:</span>
                <span className="font-medium text-gray-900">{value}</span>
              </div>
            );
          })}
        </div>
      </div>

      <div className="bg-yellow-50 rounded-lg p-4">
        <div className="flex items-center space-x-2 mb-2">
          {SvgMapper.combinationIcon("w-5 h-5 text-yellow-600")}
          <h4 className="font-medium text-yellow-900">Combination Possibilities</h4>
        </div>
        <p className="text-sm text-yellow-800">
          With your current selections, you can create
          <span className="font-bold"> 1,200 </span>
          unique interview combinations!
        </p>
      </div>
    </div>
  );
};

export default InterviewPreview;
